// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"722":"7871f5078ecc8c07","6606":"8f1644eb5edc5705"}[chunkId] + ".js";
};